var indentStyle = {"indentZero":"_9GPuM","indentOne":"pfayk","indentTwo":"tmBgx","indentThree":"JBZLo","indentFour":"YYk2-","indentFive":"xv7t2","indentSix":"_7BIZH"};

export { indentStyle as i };
//# sourceMappingURL=indentation-91737990.js.map
